import { UseTokenPaginationReturn, useTokenPagination } from '../../../../common/hooks/use-token-pagination';
import { useValidateUsersShallowStore } from '../../../stores/validate-users-store';
import { usePreviewQueryBase, DEFAULT_PAGE_SIZE } from './use-preview-query-base';

export const usePreviewPagination = ({ enabled }: { enabled: boolean }): UseTokenPaginationReturn => {
  const { filters } = useValidateUsersShallowStore('filters');

  return useTokenPagination({
    enabled,
    filterKey: `${filters.searchValue}|${filters.location}`,
    defaultPageSize: DEFAULT_PAGE_SIZE,
    useQuery: usePreviewQueryBase,
  });
};
